import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from '../../api';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/EnterpriseDetails.css";
import filterIcon from "../../assets/icons/filterIcon.png";
import changeStatusIcon from "../../assets/icons/changeStatusIcon.png";
import deleteIcon from "../../assets/icons/deleteIcon.png";
import trainDoc from "../../assets/icons/TrainDoc.png";
import trainText from "../../assets/icons/TrainText.png";
import trainUrls from "../../assets/icons/TrainUrl.png";
import trainVideo from "../../assets/icons/TrainVideo.png";
import trainQA from "../../assets/icons/TrainQA.png";
import { getFilteredDocs } from "../../utils/approvedContentTabs";

const YoutubeHistory = () => {
  const [uploadedFilesList, setUploadedFilesList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [allApprovedDocs, setAllApprovedDocs] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname;

  const tabs = [
    { name: "Documents", path: "/user/documenthistory" },
    { name: "URL", path: "/user/urlshistory" },
    { name: "Text", path: "/user/texthistory" },
    { name: "Video", path: "/user/videohistory" },
    // { name: "Q&A", path: "/user/qahistory" },
  ];

  useEffect(() => {
    // fetchApprovedDocs();
  }, []);

  const token =
    localStorage.getItem("access_token") || sessionStorage.getItem("access_token");

  // const fetchApprovedDocs = async () => {
  //   try {
  //     const res = await api.get(
  //       `${process.env.REACT_APP_API_URL}/uploaded-files/all-approved`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     setAllApprovedDocs(res.data);
  //   } catch (error) {
  //     console.error("❌ Error fetching approved docs:", error);
  //   }
  // };

  const youtubeFiles = getFilteredDocs(allApprovedDocs, "youtube");

  const filteredFiles = youtubeFiles
    .filter((file) =>
      file.name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((file) => {
      if (!dayFilter) return true;
      const updatedDate = new Date(file.updatedAt);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (dayFilter === "Today") return updatedDate >= today;
      if (dayFilter === "Yesterday") {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return updatedDate >= yesterday && updatedDate < today;
      }
      return true;
    })
    .sort((a, b) => {
      const dateA = new Date(a.updatedAt);
      const dateB = new Date(b.updatedAt);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

  const totalEntries = filteredFiles.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredFiles.slice(indexOfFirst, indexOfLast);
  const showingFrom = totalEntries === 0 ? 0 : indexOfFirst + 1;
  const showingTo = Math.min(indexOfLast, totalEntries);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageClick = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleReset = () => {
    setSortOrder("desc");
    setDayFilter("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const statsData = [
    {
      label: "Uploaded Documents",
      // value: ,
      icon: trainDoc,
    },
    {
      label: "Uploaded URL",
      // value: ,
      icon: trainUrls,
    },
    {
      label: "Uploaded Text",
      // value: ,
      icon: trainText,
    },
    {
      label: "Uploaded Video",
      icon: trainVideo,
    },
    {
      label: "Uploaded Q&A",
      // value: ,
      icon: trainQA,
    },
  ];

  return (
    <div className="mx-2 pt-1 h-100">
      <div className="d-flex flex-wrap gap-3 mb-0 justify-content-evenly align-items-stretch">
        {statsData.map((item, index) => (
          <div
            key={index}
            className="dashboard-box p-3 rounded shadow-sm d-flex flex-column justify-content-between"
          >
            <div className="d-flex align-items-center mb-2">
              {item.icon && (
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{
                    width: "18px",
                    height: "18px",
                  }}
                  className="icon-image"
                />
              )}
              <h6 className="ms-2 mb-0">{item.label}</h6>
            </div>

            <h2 className="fw-bold">
              {typeof item.value !== "undefined" ? item.value : "0"}
            </h2>

            <div className="box-summary">
              {item.summary && item.summary.length > 0 ? (
                item.summary.map((s, i) => (
                  <span key={i}>
                    {s.label}: {s.value}
                  </span>
                ))
              ) : (
                <span className="invisible">placeholder</span> // Keeps space but invisible
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold" style={{ fontSize: "20px" }}>
          Uploaded Documents
        </span>
      </div>

      <div className="mb-3 mt-3 tabs-wrapper">
        <div className="d-flex p-2 rounded border tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button ${
                currentTab === tab.path
                  ? "custom-btn text-white shadow-sm"
                  : "btn-link text-decoration-none"
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center">
          <select
            className="form-select w-auto"
            value={entriesPerPage}
            onChange={handleEntriesChange}
          >
            {[50, 100, 500].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <label className="ms-2 mt-2">Entries per page</label>
        </div>

        <div className="d-flex align-items-center">
          <div className="custom-search-wrapper me-3">
            <div
              className="input-group custom-search-group"
              style={{ width: "320px" }}
            >
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <div className="dropdown">
            <button
              className="icon-button filter-dropdown-toggle action-button"
              type="button"
              data-bs-toggle="dropdown"
            >
              <img src={filterIcon} alt="Filter" />
            </button>

            <div className="dropdown-menu p-2" style={{ minWidth: "200px" }}>
              <h6 className="fw-bolder text-black">Time</h6>
              <hr />
              {["asc", "desc"].map((order) => (
                <div className="form-check" key={order}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="sortOrder"
                    id={order}
                    value={order}
                    checked={sortOrder === order}
                    onChange={() => setSortOrder(order)}
                  />
                  <label className="form-check-label" htmlFor={order}>
                    {order === "asc" ? "Ascending" : "Descending"}
                  </label>
                </div>
              ))}

              <hr />
              <h6 className="fw-bolder text-black">By Day</h6>
              <hr />
              {["Today", "Yesterday", ""].map((day) => (
                <div className="form-check" key={day || "all"}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dayFilter"
                    id={day || "all"}
                    value={day}
                    checked={dayFilter === day}
                    onChange={() => setDayFilter(day)}
                  />
                  <label className="form-check-label" htmlFor={day || "all"}>
                    {day || "All"}
                  </label>
                </div>
              ))}

              <hr />
              <div className="d-flex justify-content-between mt-2">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="btn dropdown-btn bg-dark text-white btn-sm"
                  onClick={() => setCurrentPage(1)}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="text-muted fs-5">No entries found.</p>
        </div>
      ) : (
        <div className="not-disable">
          <div className="table-responsive">
            <table className="table role-table table-sm w-100">
              <thead className="text-left">
                <tr>
                  <th>Document Name</th>
                  <th>Document Type</th>
                  <th>Document Size</th>
                  <th>Document Status</th>
                  <th>Updated At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((file, index) => (
                  <tr key={file.id || index}>
                    <td
                      className="text-truncate text-left"
                      style={{ maxWidth: "150px" }}
                      title={file.name}
                    >
                      {file.name}
                    </td>
                    <td className="text-left">{file.type}</td>
                    <td className="text-left">{formatFileSize(file.size)}</td>
                    <td className="text-left">
                      <span
                        className={`badge ${
                          file.file_status === "1"
                            ? "bg-success"
                            : file.file_status === "0"
                            ? "bg-warning"
                            : "bg-danger"
                        }`}
                      >
                        {file.file_status === "1"
                          ? "Approved"
                          : file.file_status === "0"
                          ? "Pending"
                          : "Rejected"}
                      </span>
                    </td>
                    <td className="text-left">
                      {new Date(file.updatedAt).toLocaleString()}
                    </td>
                    <td className="text-left">
                      <button className="icon-button" title="Change Status">
                        <img src={changeStatusIcon} alt="Change Status" />
                      </button>
                      <button className="icon-button" title="Delete">
                        <img src={deleteIcon} alt="Delete" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-footer bgcolor fixed-bottom-footer d-flex justify-content-between align-items-center">
            <div className="refresh-prompts">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <ul className="pagination mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(1)}
                >
                  <i className="bi bi-chevron-double-left" />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left" />
                </button>
              </li>
              {pageNumbers.map((num) => (
                <li
                  key={num}
                  className={`page-item ${currentPage === num ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(num)}
                  >
                    {num}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(totalPages)}
                >
                  <i className="bi bi-chevron-double-right" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default YoutubeHistory;
